// extracted by mini-css-extract-plugin
export default {"wrap":"textEditable_wrap__3LLYu"};